import { render, staticRenderFns } from "./CvSelect.vue?vue&type=template&id=5a8f7104&"
import script from "./CvSelect.vue?vue&type=script&lang=js&"
export * from "./CvSelect.vue?vue&type=script&lang=js&"
import style0 from "./CvSelect.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports